<template>
  <transition v-if="isShow" name="notice-popup">
    <div class="popup-back">
      <section class="popup main-notice-popup">
        <h1 class="popup-title" tabindex="1">전면 팝업</h1>
        <div class="popup-button-close">
          <a href="#" @click.prevent="closePopup()">
            <img
              src="../../assets/images/common/btn-popup-close.svg"
              alt="팝업 닫기"
            />
          </a>
        </div>
        <div
          id="notice-popup-container"
          class="swiper-container popup-component01"
        >
          <div class="swiper-wrapper">
            <div
              v-for="(bottomItem, index) in bottomList"
              :key="index"
              class="swiper-slide"
            >
              <div class="popup-component01-list">
                <a
                  href="#"
                  :target="bottomTarget(index)"
                  @click.prevent.once="goDetail(bottomLink(index))"
                >
                  <img
                    :src="popupImg(bottomItem)"
                    :alt="popupAlt(bottomItem)"
                  />
                </a>
              </div>
            </div>
          </div>
          <template v-if="bottomList.length > 1">
            <div class="swiper-pagination"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </template>
        </div>
        <div class="popup-checkbox check-style">
          <input
            id="day-close"
            v-model="dayClose"
            type="checkbox"
            class="check-blue-dark"
          />
          <label for="day-close">일주일 동안 보지 않기</label>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
  import Swiper from '@/mixins/swiper'
  import { getUiserviceBannerMulti } from '@/common/utils/request'
  import { url } from '@/common/filters/url.filter'
  import cookie from '@/common/utils/cookie'
  import constant from '@/common/resources/constant'
  import { bannerLink, setDisableScrolling } from '@/common/utils/common'
  import _ from 'lodash'
  import { parseUrl } from 'query-string'
  import { resizeThumbnail } from '@/common/utils/image'
  import { getCache, setCache } from '@/common/utils/cache'
  const CACHE_KEY = 'layerpopup'

  export default {
    filters: {
      url,
    },
    mixins: [Swiper],
    data() {
      return {
        dayClose: false,
        popupInfo: [],
        isShow: false,
        swiperOptions: {
          paginationClickable: false,
          simulateTouch: false,
          spaceBetween: 50,
          slidesPerView: '1',
          loop: true,
          pagination: '.swiper-pagination',
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
        },
      }
    },
    computed: {
      bottomList() {
        return _.get(this.popupInfo, ['top_list', '0', 'bottom_list'], [])
      },
    },
    created() {
      this.init()
    },
    methods: {
      closePopup() {
        setDisableScrolling(false)
        this.popupInfo = null
        if (this.dayClose) {
          let expires = new Date()
          expires.setDate(expires.getDate() + 7)
          cookie.setItem(
            'close-popup',
            '1',
            expires.toUTCString(),
            constant.URL_COOKIE_DOMAIN,
            '/',
          )
        }
        this.isShow = false
      },
      goDetail(url) {
        const { query } = parseUrl(url)
        if (_.get(query, 'referer', '') === '') {
          url =
            Object.keys(query).length > 0
              ? url + '&referer=/'
              : url + '?referer=/'
        }
        bannerLink(url)
      },
      openPopup() {
        this.isShow = true
        this.$nextTick(() => {
          this.swiperElement = '#notice-popup-container'
          this.isReady = true
        })
        setDisableScrolling(true)
      },
      async setData() {
        try {
          if (getCache(CACHE_KEY) === null) {
            const response = await getUiserviceBannerMulti({
              bannerid: 'layerpopup',
            })
            const { data = {} } = response
            if (data?.error) return
            this.popupInfo = data
            if (this.bottomList.length > 0) {
              this.openPopup()
            }
            setCache(CACHE_KEY, data)
          }
        } catch (error) {
          console.error('배너 API 오류:', error)
        }
      },
      bottomTarget(bottomIndex = 0) {
        const link = this.bottomLink(bottomIndex)
        if (link.indexOf('www.wavve.com') >= 0) return '_self'
        else return '_blank'
      },
      bottomLink(bottomIndex = 0) {
        return _.get(this.bottomList, [bottomIndex, 'bottom_link'], '')
      },
      init() {
        if (cookie.getItem('close-popup') !== '1') {
          this.setData()
        }
      },
      popupImg(item) {
        return resizeThumbnail(_.get(item, 'bottom_img', ''), {
          width: 0,
          height: 0,
          option: 20,
          quality: 80,
        })
      },
      popupAlt(item) {
        return _.get(item, 'bottom_text1', '')
      },
    },
  }
</script>

<style>
  .notice-popup-enter-active,
  .notice-popup-leave-active {
    transition: opacity 0.3s;
  }

  .notice-popup-enter,
  .notice-popup-leave-to {
    opacity: 0;
  }
</style>
